import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { GetFeeResponse } from '../model/get-fee-response';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OneIncHttpService {

  constructor(private http: HttpClient) {
  }

  getPaymentSessionId(): Observable<any> {
    const apiUrl = `/api/OneInc/getSessionId`;
    return this.http.get(apiUrl);
  }

  // This service is to save payment details for making one time payment
  saveOneIncPaymentDetails(data) {
    const apiUrl = `/api/savePaymentDetails`;
    return this.http.post(apiUrl, data,
        {
          observe: 'response'
        }
    ).pipe(
        map(res => {
          return res.body;
        })
    );
  }

  // This service is to know the processing fee and total amount
  getConvenienceFee(data): Observable<GetFeeResponse> {
    const apiUrl = `/api/getFee`;
    return this.http.post<GetFeeResponse>(apiUrl, data,
        {
          observe: 'response'
        }
    ).pipe(
        map(res => {
          return res.body;
        })
    );
  }
}
